module.exports = __webpack_public_path__ + "static/media/redux.86286614.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Logos/redux.svg
// module id = 1561
// module chunks = 0